import React from "react";
import {
    Drawer,
    DrawerBody,
    DrawerOverlay,
    DrawerContent,
    useDisclosure, Image, Box, Flex,
} from "@chakra-ui/react";

const SplashScreen: React.FC = () => {
    const { isOpen=true, onOpen, onClose } = useDisclosure();
    React.useEffect(() => {
        onOpen();
        setTimeout(() => onClose(), 2000);
    }, [])

    return <>
        <Drawer
            isOpen={isOpen}
            placement="top"
            onClose={onClose}
            size="full"
            isFullHeight={true}
        >
            <DrawerOverlay />
            <DrawerContent bg="black">
                <DrawerBody>
                   <Flex w={"100%"} h={"100%"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} >
                       <Box width={"100px"} height={"100px"}>
                           <Image
                               src={"https://assets.website-files.com/6148548ab244696560ef92dd/614e501f01afbc0ebece188d_Numbers_Icon%20White.svg"}
                               height={"100%"}
                               width={"100%"}
                           />
                       </Box>
                   </Flex>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    </>;
}

export default SplashScreen;